/* Trustpilot review widget behaviour for sections/product-trustpilot-reviews.liquid.
 *
 * Moved out of two inline <script> blocks (~10KB) that were re-sent inside every product
 * page's HTML. HTML is not cacheable, so those bytes were paid for on every view; as an
 * asset it is fetched once and then served from cache.
 *
 * The Liquid values it used are now data attributes on the section root:
 *   data-fi-tp-root             marks the section (was 'shopify-section-' + section.id)
 *   data-fi-tp-fallback-delay   seconds before the star fallback gives up
 *   data-fi-tp-mobile-carousel  whether the phone carousel owns the TrustBox request
 *   data-fi-tp-fallback-poll    whether to poll at all (was: show_fallback and tp_has_sku)
 *
 * Behavioural note: the fallback-poll and carousel paths used to be omitted from the HTML
 * entirely when their settings were off. They are now always present here and inert at
 * runtime instead -- the trade for having one cacheable asset.
 *
 * Deferred, and it bails out when its markup is absent, so load order does not matter.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-fi-tp-root]');
  if (!root) return;

  (function () {
    window.FITP = window.FITP || {};

    /* Shared by every instance of this section, and by the phone carousel when
       it hands the TrustBox back. */
    if (!window.FITP.whenTrustpilot) {
      (function () {
        var SRC = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
        var MATCH = 'tp.widget.bootstrap';
        var waiting = [];
        var poll = null;
        var ticks = 0;

        /* The same test delayed-scripts.liquid makes, for the same reason: the
           bootstrap is embedded directly on ~25 templates, so whichever side
           gets there first has to be the only one that fetches it. data-src
           counts because delay-third-party-inline.liquid parks src there while
           a script is held. */
        function alreadyOnPage() {
          var tags = document.querySelectorAll('script[src], script[data-src]');
          for (var i = 0; i < tags.length; i++) {
            var url = tags[i].getAttribute('src') || tags[i].getAttribute('data-src') || '';
            if (url.indexOf(MATCH) !== -1) return true;
          }
          return false;
        }

        function request() {
          if (window.Trustpilot || alreadyOnPage()) return;
          var script = document.createElement('script');
          script.src = SRC;
          script.async = true;
          document.head.appendChild(script);
        }

        function stop() {
          clearInterval(poll);
          poll = null;
        }

        function drain() {
          /* A ceiling only so a page where the bootstrap never arrives is not
             left with a timer ticking for the rest of the visit. */
          if (++ticks > 400) {
            stop();
            return;
          }
          if (!window.Trustpilot) return;
          stop();
          var queue = waiting;
          waiting = [];
          for (var i = 0; i < queue.length; i++) {
            try {
              queue[i]();
            } catch (e) {}
          }
        }

        /* Waits for the bootstrap; deliberately does NOT request it. Callers
           run at parse time, and fetching from here would put Trustpilot back
           on the critical path — which is the whole thing the theme's loader
           exists to avoid. requestTrustpilot decides when to fetch.

           No timeout on the callbacks on purpose: if Trustpilot never loads
           then neither could the fallback widget, so the right outcome there is
           to leave the plain link standing. */
        function whenTrustpilot(cb) {
          if (typeof cb !== 'function') return;
          if (window.Trustpilot) {
            cb();
            return;
          }
          waiting.push(cb);
          if (!poll) poll = setInterval(drain, 150);
        }

        window.FITP.requestTrustpilot = request;
        window.FITP.whenTrustpilot = whenTrustpilot;
      })();
    }

    var section = root;
    var asked = false;

    function ask() {
      if (asked) return;
      asked = true;
      window.FITP.requestTrustpilot();
    }

    if (section && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            observer.disconnect();
            ask();
            return;
          }
        },
        { rootMargin: '800px 0px' }
      );
      observer.observe(section);
    }

    /* Backstop for the visitor who never scrolls this far, and for the sticky
       header's Reviews tab jumping straight here: after load and at idle, so it
       cannot land on the critical path. */
    function askWhenIdle() {
      if (window.requestIdleCallback) {
        requestIdleCallback(ask, { timeout: 3000 });
      } else {
        setTimeout(ask, 1200);
      }
    }
    if (document.readyState === 'complete') askWhenIdle();
    else window.addEventListener('load', askWhenIdle, { once: true });
  })();

  if (root.getAttribute('data-fi-tp-fallback-poll') !== 'true') return;

  (function () {
    var widget = document.querySelector('[data-fi-trustpilot-product]');
    var fallback = document.querySelector('[data-fi-trustpilot-fallback]');
    if (!widget || !fallback) return;

    var heading = document.querySelector('[data-fi-tp-heading]');
    var tries = 0;
    var limit = (parseInt(root.getAttribute('data-fi-tp-fallback-delay'), 10) || 8) * 2;
    var started = false;
    var swapped = false;
    var timer = null;

    function showFallback() {
      if (swapped) return;
      swapped = true;
      widget.hidden = true;
      fallback.hidden = false;

      var fallbackHeading = heading && heading.getAttribute('data-fallback-heading');
      if (heading && fallbackHeading) heading.textContent = fallbackHeading;

      /* Trustpilot cannot size a hidden element, so the store-wide widget is
         drawn only now that it is on screen. */
      var el = fallback.querySelector('.trustpilot-widget');
      if (!el) return;
      window.FITP.whenTrustpilot(function () {
        if (window.Trustpilot && window.Trustpilot.loadFromElement) {
          window.Trustpilot.loadFromElement(el, true);
        }
      });
    }

    /* ---- asking Trustpilot outright ----
       The height poll below can only infer "no reviews" from an iframe that
       never grew, and this widget is asked for at data-style-height 700px,
       so a range with nothing to show can still leave a full-height empty
       frame standing — and the swap then never happens.

       The same endpoint fi-tp-carousel.js reads answers the question
       directly: no token, CORS open, and it takes the very SKU list already
       on the widget, so its answer is exactly what the TrustBox would draw.
       Nothing is swapped until it has replied, so a range with reviews is
       never disturbed. */
    function askTrustpilot() {
      var sku = widget.getAttribute('data-sku');
      var template = widget.getAttribute('data-template-id');
      if (!sku || !template || !window.fetch) return false;

      var params = [
        'businessUnitId=' + encodeURIComponent(widget.getAttribute('data-businessunit-id') || ''),
        'locale=' + encodeURIComponent(widget.getAttribute('data-locale') || 'en-GB'),
        'sku=' + encodeURIComponent(sku),
        /* One is enough to answer "are there any?" — the TrustBox fetches
           the rest for itself. */
        'reviewsPerPage=1'
      ];
      var languages = widget.getAttribute('data-review-languages');
      if (languages) params.push('reviewLanguages=' + encodeURIComponent(languages));

      fetch(
        'https://widget.trustpilot.com/trustbox-data/' +
          encodeURIComponent(template) +
          '?' +
          params.join('&'),
        { headers: { Accept: 'application/json' }, credentials: 'omit' }
      )
        .then(function (response) {
          if (!response.ok) throw new Error('status ' + response.status);
          return response.json();
        })
        .then(function (data) {
          var reviews = (data.productReviews && data.productReviews.reviews) || [];
          if (!reviews.length) showFallback();
        })
        .catch(function () {
          /* Endpoint moved, blocked or offline — fall back to watching the
             iframe, which is how this worked before. */
          startFallbackPoll();
        });

      return true;
    }

    window.FITP = window.FITP || {};
    window.FITP.showTrustpilotFallback = showFallback;

    /* Exposed rather than started outright, because on a phone the native
       carousel takes the TrustBox out of the bootstrap's reach — its iframe
       then never grows, and this poll would read that as "no reviews" for a
       range that has plenty. The carousel starts it if it gives up. */
    function startFallbackPoll() {
      if (started) return;
      started = true;

      /* Counted from the moment the bootstrap has run, never from page parse:
         the deadline is meant to measure how long Trustpilot takes to draw the
         gallery, not how long the loader took to fetch the script. */
      window.FITP.whenTrustpilot(function () {
        timer = setInterval(function () {
          tries++;
          var frame = widget.querySelector('iframe');
          /* A rendered gallery is tall; an empty one is hidden or near-zero. */
          if (frame && frame.getBoundingClientRect().height > 40) {
            clearInterval(timer);
            return;
          }
          if (tries < limit) return;

          clearInterval(timer);
          showFallback();
        }, 500);
      });
    }

    window.FITP.startFallbackPoll = startFallbackPoll;

    /* Ask outright where we can; watch the iframe only where we cannot. */
    function decide() {
      if (!askTrustpilot()) startFallbackPoll();
    }

    /* On a phone the carousel makes this same request for itself and hands back if
       the range turns out to be empty, so asking here too would just be a second
       identical fetch. Wide screens have no carousel, so the question is ours to ask.
       This was a Liquid if before the script became an asset -- same test, now read
       from the section root at runtime. */
    if (root.getAttribute('data-fi-tp-mobile-carousel') === 'true') {
      if (!window.matchMedia('(max-width: 749px)').matches) decide();
    } else {
      decide();
    }
  })();
})();
